<template>
  <div class="confirm-wrap" v-if="visible">
    <div class="confirm-title">{{content}}</div>
    <div class="img-wrap">
      <img src="@/assets/images/confirm_img.png" alt="" />
    </div>
    <div class="confirm-button-wrap">
      <div class="cancel-button" @click="close">我在想想</div>
      <div class="confirm-button" @click="close('confirm')">确定</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Confirm',
  data () {
    return {
      visible: false,
      content: '',
      title: ''
    }
  },
  methods: {
    confirm () {
      this.visible = true;
      return new Promise((resolve, reject) => {
        this.promiseStatus = { resolve, reject };
      })
    },
    close (val) {
      this.visible = false;
      if (val === 'confirm') {
        this.promiseStatus && this.promiseStatus.resolve();
      } else {
        this.promiseStatus && this.promiseStatus.reject();
      }
    }
  }
}
</script>

<style lang="less" scoped>
.confirm-wrap{
  position: fixed;
  z-index: 1111;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.2);
  width: 420px;
  padding: 30px 0;
  background: #FFFFFF;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  .confirm-title{
    font-size: 18px;
    font-weight: bold;
    color: #666666;
    line-height: 6px;
    margin-bottom: 10px;
    margin-top: 10px;
  }
  .img-wrap{
    width: 230px;
    height: 172px;
    img{
      width: 100%;
      height: 100%;
    }
  }
  .confirm-button-wrap{
    margin-top: 10px;
    display: flex;
    width: 300px;
    justify-content: space-between;
    div{
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 140px;
      height: 38px;
      border-radius: 3px;
      font-size: 14px;
      cursor: pointer;
    }
    .cancel-button{
      background: #fff;
      color: #2A55A4;
      border: 1px solid #2A55A4;
    }
    .confirm-button{
      background: #2A55A4;
      color: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ConfirmBox/ConfirmBox.vue